import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var updateExpenseSlice = createSlice({
    name: "updateExpense",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _updateExpenseSlice_actions = updateExpenseSlice.actions;
export var fetchData = _updateExpenseSlice_actions.fetchData, fetchDataSuccess = _updateExpenseSlice_actions.fetchDataSuccess, fetchDataFailure = _updateExpenseSlice_actions.fetchDataFailure, resetState = _updateExpenseSlice_actions.resetState;
export default updateExpenseSlice.reducer;
